// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1yGSZ","image":"Header_image__3Apl4","name":"Header_name__rxEUR","info":"Header_info__aMIjg","infoRow":"Header_infoRow__3AAJF"};